export default "__VITE_ASSET__BtUMwh00__"